import { Component, OnInit, inject, computed } from '@angular/core';
import { NovaButton } from '@rds-nova/angular-button';
import { NovaIcon } from '@rds-nova/angular-icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';

import { TrackedButtonDirective } from 'src/app/core/analytics/directives/tracked-button.directive';

import { LanguageService } from '../../../core/services/language.service';
import { Language } from '../../../core/models/language.model';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  standalone: true,
  imports: [NovaButton, NovaIcon, MatMenuModule, TrackedButtonDirective, TranslatePipe],
})
export class LanguageSelectorComponent implements OnInit {
  availableLanguages: Language[] = [];
  languageService = inject(LanguageService);

  currentLanguage = computed(() =>
    this.languageService.currentLanguage(),
  );

  ngOnInit(): void {
    this.availableLanguages = this.languageService.availableLanguages;
  }

  selectLanguage(language: Language): void {
    this.languageService.setLanguage(language.code);
  }

  getCurrentLanguageInfo(): Language {
    return this.languageService.currentLanguageDetails();
  }
}
